import { useSettings } from "@/lib/settings";

export function Encerramento() {
  const { settings } = useSettings();
  return (
    <footer data-testid="footer" className="relative border-t border-dourado/15 bg-vinho">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8 lg:px-14">
        <div className="flex flex-col items-center gap-8 text-center">
          <div className="flex items-center gap-3">
            <svg viewBox="0 0 64 64" className="h-7 w-7" aria-hidden="true">
              <path d="M42 8a26 26 0 1 0 12 40A30 30 0 0 1 42 8z" fill="none" stroke="#D6AF62" strokeWidth="3" />
              <circle cx="46" cy="16" r="2" fill="#D6AF62" />
            </svg>
            <span className="font-cinzel text-sm tracking-[0.35em] text-dourado">
              MEU EX DE VOLTA
            </span>
          </div>

          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-xs uppercase tracking-[0.2em] text-creme/60" aria-label="Links legais">
            <a href="/legal/privacidade" data-testid="footer-link-privacidade" className="transition-colors hover:text-dourado">
              Política de Privacidade
            </a>
            <a href="/legal/termos" data-testid="footer-link-termos" className="transition-colors hover:text-dourado">
              Termos de Uso
            </a>
            <a href="/legal/contato" data-testid="footer-link-contato" className="transition-colors hover:text-dourado">
              Contato
            </a>
            <a href="/legal/produto-digital" data-testid="footer-link-produto" className="transition-colors hover:text-dourado">
              Produto Digital
            </a>
          </nav>

          {settings.support_contact && (
            <p className="text-xs text-creme/50" data-testid="footer-contato">
              Suporte: {settings.support_contact}
            </p>
          )}

          <p className="max-w-3xl text-xs leading-relaxed text-creme/45" data-testid="footer-aviso">
            Este material possui finalidade cultural, simbólica e espiritual.
            Não oferece garantias de resultados amorosos ou de reconciliação.
          </p>
          <p className="text-[0.65rem] uppercase tracking-[0.25em] text-creme/35">
            © {new Date().getFullYear()} Meu Ex de Volta · Todos os direitos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
